export default __webpack_public_path__ + "static/media/SRI_90Days.a548b1cc.webm";